import React from 'react';
import * as Icon from 'react-feather';
import axios from '../util/Api';
import { merchandisesKey, tokensKey } from '../util/Constants';
import getStorage from '../context/auth';
import 'antd/dist/antd.css';
import { Select, Spin } from 'antd';

const { Option } = Select;

export default class MerchandiseSelector extends React.Component {
  state = {
    merchandises: [],
    selected: this.props.defaultValue
      ? { value: this.props.defaultValue.id, label: this.props.defaultValue.name }
      : undefined,      // nothing selected
    loading: true,
  };

  componentDidMount() {
    const cached = getStorage().getItem(merchandisesKey);
    const ONE_HOUR = 60 * 60 * 1000;

    if (cached) {
      const { date, merchandises } = JSON.parse(cached);
      if (Date.now() - date < ONE_HOUR) {
        this.setState({ merchandises, loading: false }, this.fireDefault);
        return;
      }
    }
    this.fetchData();
  }

  /* ---------- helpers ---------- */
  fireDefault = () => {
    const { selected, merchandises } = this.state;
    if (!selected) return;
    const item = merchandises.find((m) => m.id === selected.value);
    if (item && this.props.onSelected) this.props.onSelected(item);
  };

  fetchData = () => {
    const token = JSON.parse(getStorage().getItem(tokensKey) || '{}');
    if (!token.jwt) return;

    axios
      .get('/api/marchandises/all', {
        headers: { Authorization: `Bearer ${token.jwt}` },
      })
      .then(({ status, data }) => {
        if (status === 200) {
          const merchandises = data.data;
          getStorage().setItem(
            merchandisesKey,
            JSON.stringify({ date: Date.now(), merchandises })
          );
          this.setState({ merchandises, loading: false }, this.fireDefault);
        }
      })
      .catch(() => this.setState({ loading: false }));
  };

  handleChange = (option /* { value, label } */) => {
    // allowClear -> option can be undefined
    if (!option || option.value === undefined || option === null) {
      this.setState({ selected: undefined });
      if (this.props.onSelected) this.props.onSelected(null);
      return;
    }
    this.setState({ selected: option });
    const item = this.state.merchandises.find((m) => m.id === option.value);
    if (item && this.props.onSelected) this.props.onSelected(item);
  };

  /* ---------- render ---------- */
  render() {
    const { merchandises, selected, loading } = this.state;
    const selectClassName = ['mja-select', this.props.className].filter(Boolean).join(' ');
    const dropdownClassName = ['mja-select-dropdown', this.props.dropdownClassName].filter(Boolean).join(' ');

    if (loading) return <Spin />;

    return (
      <Select
        showSearch
        size="large"
        className={selectClassName}
        style={this.props.style || { width: '100%' }}
        placeholder={this.props.placeholder || "La marchandise"}
        allowClear
        dropdownMatchSelectWidth
        dropdownClassName={dropdownClassName}
        getPopupContainer={(node) => node.parentNode}
        suffixIcon={<Icon.ChevronDown size={18} />}
        labelInValue                /* <-- crucial */
        optionFilterProp="label"
        value={selected}
        onChange={this.handleChange}
        filterOption={(input, option) =>
          option.label.toLowerCase().includes(input.toLowerCase())
        }
      >
        {merchandises.map((m) => (
          <Option key={m.id} value={m.id} label={m.name}>
            {m.name}
          </Option>
        ))}
      </Select>
    );
  }
}
